import TF from 'components/TabTextField'
import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: TF,
  name: 'DDITabTextField'
})
